<script setup>
import ChatView from "@/views/ChatView.vue";
</script>
<!-- Diese Komponente wird angezeigt, wenn keine andere Route zur URL passt (404-Fehler). -->
<template>
  <div class="not-found">
    <h1>404</h1>
    <p>Seite nicht gefunden</p>
    <p>Leider bist du im Nirgendwo geladen ^^. Falls es ein Problem mit Wetter-Wetter gibt an wende Dich doch bitte an uns.</p>
    <p><a href="mailto:support@bonnerWettWetter.de">support@bonnerWettWetter.de</a></p>

    <!-- Ein Link, um zur Startseite zurückzukehren. -->
    <router-link to="/" class="home-btn">Zur Startseite</router-link>

    <!-- Ein Easter-Egg-Chat für die "Nirgendwo"-Seite. -->
    <ChatView chatId="nirgendwo" />
  </div>
</template>

<style scoped lang="scss">
.not-found {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

h1 {
  font-size: 5rem;
  margin: 0;
}

p {
  opacity: 0.7;
  margin-bottom: 1.5rem;
}

.home-btn {
  padding: 0.75rem 1.25rem;
  border-radius: 10px;
  background: $primary-color;
  color: white;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    background: $primary-color-hover;
  }
}
</style>